
import merge from '~lodash.mergewith'
import { init } from '~@sentry/vue'
import * as CoreSdk from '~@sentry/core'
import * as BrowserSdk from '~@sentry/browser-sdk'
import { ExtraErrorData, ReportingObserver, RewriteFrames } from '~@sentry/integrations'

export { init }
export const SentrySdk = { ...CoreSdk, ...BrowserSdk }

export function getConfig (ctx) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002Fbec9ea319ad843f899767e6a9c7f9e9b@o4504583182548992.ingest.sentry.io\u002F4504586645209088",
    environment:"production",
    beforeBreadcrumb:function(breadcrumb) {
        if (breadcrumb.category === 'xhr' && /(mc\.yandex\.ru\/webvisor)|(google-analytics\.com)|(jivosite\.com)/.test(breadcrumb.data.url)) {
          return null;
        }
        return breadcrumb;
      },
  }

  config.integrations = [
    new ExtraErrorData(),
    new ReportingObserver({ types:["crash"] }),
    new RewriteFrames(),
  ]

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
